// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const CrashFilters = registerClientReference(
    function() { throw new Error("Attempted to call CrashFilters() from the server but CrashFilters is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/app/(admin)/crashs-mobile/_components/crash-filters.tsx",
    "CrashFilters",
);
